module.exports = __webpack_public_path__ + "static/img/avatar02.b3674f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar02.jpg
// module id = mYTn
// module chunks = 1